import React, { useEffect, useState, useContext } from "react";
// import "../pages/Plan.css";

import LogicContext from "../../Context/LogicContext";
import NotificationContext from "../../Context/NotificationContext";
import {
  SetChartEntryMasterData,
  GetChartEntryMasterData,
  GetChartEdit,
  ResetChartEdit,
} from "../../store/chartOfAccountAtom";
import { useForm } from "react-hook-form";
import moment from "moment";

import { useNavigate } from "react-router-dom";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

import EntrySelect from "./ChartOfAccountTypeSelect";
import { accountService } from "../../services/accountService";
import ChartOfAccountTypeSelect from "./ChartOfAccountTypeSelect";
import ChartOfAccountParentName from "./ChartOfAccountParentName";
import ChartOfAccountCurrency from "./ChartOfAccountCurrency";
import ChartMakeSubAccount from "./ChartmakeSubAccount";
import ChartAccountAddWatchList from "./ChartAccountAddWatchList";
import ChartAccountShowAsActive from "./ChartAccountShowAsActive";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function AddNewChartOfAccountPage() {
  const setMasterData = SetChartEntryMasterData();
  const getMasterData = GetChartEntryMasterData();
  const getChartEdit = GetChartEdit();
  const resetChartEdit = ResetChartEdit();
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const logicContext = useContext(LogicContext);
  const notificationContext = useContext(NotificationContext);
  const myPromiseModal = createModal(GeneralModal);
  const navigate = useNavigate();
  const [showSubAccount, setShowSubAccount] = useState(false);
  const [trackAccountType, setTrackAccountType] = useState(0);
  const [filteredAccount, setFilteredAccount] = useState([]);


  useEffect(() => {
    setValue("Currency_Id", 1);
    if (getChartEdit?.Account_Id) {
      setValue("Account_Id", getChartEdit?.Account_Id);
      setTrackAccountType(getChartEdit?.Account_Type_Id);
      onAccountTypeSelect(getChartEdit?.Account_Type_Id)

      setValue("Account_Type_Id", getChartEdit?.Account_Type_Id);
      setValue("Account_Name", getChartEdit?.Account_Name);
      setValue("Account_Number", getChartEdit?.Account_Number);
      setValue("Account_Description", getChartEdit?.Account_Description);
      setValue("Currency_Id", getChartEdit?.Currency_Id);
      setValue("Currency_Id", getChartEdit?.Currency_Id);
      setValue("Show_WatchList_Id", getChartEdit?.Show_WatchList_Id);
      setValue("Account_Status_Id", getChartEdit?.Account_Status_Id);
      if (getChartEdit?.Parent_Account_Name !== null) {
        setShowSubAccount(true);
        setValue("Parent_Account_Id", getChartEdit?.Parent_Account_Id);
      }

      
    }

  


    return () => {
      resetChartEdit();
      setMasterData({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getChartEdit?.Account_Id]);

  useEffect(()=> {
    let isMounted = true;
    if(!getMasterData['Account_Main']){
      accountService.getChartEntryMasterData().then((response) => {
        if (isMounted && response?.data !== undefined) {
          setMasterData(response.data);
        }
      });
    }
    return () => {
      isMounted = false;
    };
  },[]);

  const filterSubAccountList = (type_id) => {
    const customOption = getMasterData["Parent_Account"]?.map((item) => {
      return { ...item, label: `${item.Account_Name}` };
    });
    const selections = customOption?.filter((acc) => {
      if (acc.Account_Type_Id === type_id) {
        return acc;
      }
    });
    setFilteredAccount(selections);
  };


  function onAccountTypeSelect(Account_Type_Id) {
    setValue("Account_Type_Id", Account_Type_Id);
    setTrackAccountType(Account_Type_Id);
    filterSubAccountList(Account_Type_Id);
  }

  

  function subAccountSelect(decision) {
    if(decision === false){
      setValue("Parent_Account_Id", 0);
    }
   
    setShowSubAccount(decision);
  }


  function onParentNameSelect(selection) {
    setValue("Parent_Account_Id", selection.Account_Id);
  }


  function onCurrencySelect(currency) {
    setValue("Currency_Id", currency?.Currency_Id);
  }


  function addToWatchList(selection) {
    setValue("Show_WatchList_Id", selection);
  }

  function addShowAsActive(selection) {
    setValue("Account_Status_Id", selection);

  }

  const onSubmit = async () => {
    let formData = getValues();
    let option = 1;
    if (getChartEdit?.Account_Id !== undefined) {
      option = 2;
    }
    const checkValue = getValues("Account_Type_Id");
    if (checkValue === undefined) {
      return logicContext.showToast("Account type is required", "error");
    }

    await myPromiseModal({
      title: "Confirmation", body: " Do you want to save this record?",
      showInput: false, placeHolder: ''
    }).then((res) => {

      if (res.decision === true) {
        accountService.saveNewChartAccount({ ...formData, option: option }).then((res) => {
          const response = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);

          if (response.message_id === 1) {
            logicContext.showToast(response.message_text || 'Stock adjustment saved successfully!', 'success');
            sessionStorage.setItem('reloadPage', 'true');
            notificationContext.reloadChartList();
            navigate(-1);
          } else {
            logicContext.showToast(response.message_text || 'Failed to save', 'error');
          }
          
        })
          .catch((err) => {
            // return logicContext.showToast("Error saving record!", "error");
          });
      }
    });
  };

  function onErrors(error) {
    console.error(errors);
    logicContext.showToast("One or more value is required", "error");
  }

  return (
    <>
     <form onSubmit={handleSubmit(onSubmit, onErrors)} className="p-6 bg-gray-50 rounded-lg shadow-sm">
  <section className="mt-4">
    <div className="flex flex-col lg:flex-row gap-6">
      {/* First Column */}
      <div className="flex-1 space-y-6">
        {/* Account ID */}
        <div>
          <span className="text-sm font-semibold text-gray-700">
            Account ID: {getChartEdit?.Account_Id}
          </span>
        </div>

        {/* Account Type Select */}
        <div>
          <label className="text-sm font-medium text-gray-700">
            Account Type <span className="text-red-500">*</span>
          </label>
          <div className="mt-1">
            <ChartOfAccountTypeSelect
              defaultVal={{ label: getChartEdit?.Account_Type_Name }}
              onAccountTypeSelect={(acc) => onAccountTypeSelect(acc?.Account_Type_Id)}
              className="text-sm"
            />
          </div>
        </div>

        {/* Sub Account Checkbox */}
        <div className="flex items-center gap-2">
          <ChartMakeSubAccount
            defaultVal={showSubAccount}
            subAccountSelect={subAccountSelect}
          />
          <span className="text-xs text-gray-600">Make this a sub account</span>
        </div>

        {/* Parent Account (Conditional) */}
        {showSubAccount && (
          <div>
            <label className="text-sm font-medium text-gray-700">Parent Account</label>
            <div className="mt-1">
              <ChartOfAccountParentName
                subList={filteredAccount}
                defaultVal={{ label: getChartEdit?.Parent_Account_Name }}
                onParentNameSelect={onParentNameSelect}
                className="text-sm"
              />
              {!filteredAccount?.length && (
                <small className="text-red-500 text-xs">
                  No Parent account for selected account type
                </small>
              )}
            </div>
          </div>
        )}

        {/* Account Name */}
        <div>
          <label className="text-sm font-medium text-gray-700">
            Account Name <span className="text-red-500">*</span>
          </label>
          <div className="mt-1">
            <input
              {...register("Account_Name", {
                required: "Account Name is required!",
              })}
              className="w-full bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
              type="text"
            />
            {errors?.Account_Name && (
              <small className="text-red-500 text-xs">
                {errors.Account_Name.message}
              </small>
            )}
          </div>
        </div>
      </div>

      {/* Second Column */}
      <div className="flex-1 space-y-6">
        {/* Description */}
        <div>
          <label className="text-sm font-medium text-gray-700">Description</label>
          <div className="mt-1">
            <textarea
              {...register("Account_Description", {})}
              className="w-full h-32 bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
              type="text"
            />
          </div>
        </div>

        {/* Watch List and Active Account Checkboxes */}
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <ChartAccountAddWatchList
              defaultVal={getChartEdit?.Show_WatchList_Id}
              addToWatchList={addToWatchList}
            />
            <span className="text-xs text-gray-600">
              Add to watch list on my dashboard
            </span>
          </div>
          <div className="flex items-center gap-2">
            <ChartAccountShowAsActive
              defaultVal={getChartEdit?.Account_Status_Id}
              addShowAsActive={addShowAsActive}
            />
            <span className="text-xs text-gray-600">Show as an active account</span>
          </div>
        </div>

        {/* Currency and Account Number (Conditional) */}
        {(trackAccountType === 1 || trackAccountType === 9) && (
          <>
            {/* Currency */}
            <div>
              <label className="text-sm font-medium text-gray-700">Currency</label>
              <div className="mt-1">
                <ChartOfAccountCurrency
                  defaultVal={{
                    label: getChartEdit?.Currency_Name_Short,
                  }}
                  onCurrencySelect={onCurrencySelect}
                  className="text-sm"
                />
              </div>
            </div>

            {/* Account Number */}
            <div>
              <label className="text-sm font-medium text-gray-700">Account Number</label>
              <div className="mt-1">
                <input
                  {...register("Account_Number", {})}
                  className="w-full bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                  type="number"
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  </section>

  {/* Action Buttons */}
  <section className="mt-6 flex justify-between">
    <button
      type="button"
      onClick={() => navigate(-1)}
      className="text-sm text-red-500 font-medium px-4 py-2 rounded-md hover:text-red-600 transition-colors"
    >
      Cancel
    </button>
    <button
      type="submit"
      className="text-sm bg-blue-600 text-white font-medium px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
    >
      Save
    </button>
  </section>
</form>

    </>
  );
}

export default AddNewChartOfAccountPage;
